export default __webpack_public_path__ + "static/media/authorizationIcon.69464197.svg";